export class SHIFT_SUMMARY {

  CARD_SOLD_COUNT: string;
  CARD_SOLD_VALUE: string;
  CARD_RENEW_COUNT: string;
  CARD_RENEW_VALUE: string;
  CASH_PAYMENT_COUNT: string;
  CASH_PAYMENT_VALUE: string;
  E_PAYMENT_COUNT: string;
  E_PAYMENT_VALUE: string;
  CARD_TOTAL_COUNT: string;
  CARD_TOTAL_VALUE: string;
  COLLECTIONS: string;
  PROFIT: string;

  constructor() {
    this.CARD_SOLD_COUNT = '';
    this.CARD_SOLD_VALUE = '';
    this.CARD_RENEW_COUNT = '';
    this.CARD_RENEW_VALUE = '';
    this.CASH_PAYMENT_COUNT = '';
    this.CASH_PAYMENT_VALUE = '';
    this.E_PAYMENT_COUNT = '';
    this.E_PAYMENT_VALUE = '';
    this.CARD_TOTAL_COUNT = '';
    this.CARD_TOTAL_VALUE = '';
    this.COLLECTIONS = '';
    this.PROFIT = '';
  }
}
